import UpdateComponent from 'components/table/UpdateComponent';
import { getMintConditionById, update } from 'controllers/MindCondition';
import React, { useState, useEffect,useCallback } from 'react'
import {  useParams ,useHistory} from 'react-router-dom';

function UpdateMintCondition() {
  const [inputText, setInputText] = useState('');

  const { id } = useParams()
  const history = useHistory();


  const handleChange = (event) => {
      setInputText(event.target.value);
    };
  
const handleClick = () => {
  update({ id:id,value: inputText, label: inputText },history)
  };
  
 const dataStream =   useCallback( async () => {
  const typeofgarment = await getMintConditionById(id);
    setInputText(typeofgarment.value)
}, [id]); 
  
  
  useEffect(() => {
    dataStream()
},[dataStream])

    return (
    <>
      <div style={{display:'flex',justifyContent:'center',marginTop:'2%'}}>
          <UpdateComponent
            lebel="Condition"
            inputText={inputText}
            handleChange={handleChange}
            handleClick={handleClick}
          />
            
      </div>
    </>
  )
}

export default UpdateMintCondition;